__turbopack_context__.v({
  "feature": "feature-list-module-scss-module__U73wGq__feature",
  "feature-list": "feature-list-module-scss-module__U73wGq__feature-list",
  "label": "feature-list-module-scss-module__U73wGq__label",
  "list": "feature-list-module-scss-module__U73wGq__list",
  "value": "feature-list-module-scss-module__U73wGq__value",
});
